import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";

export function SearchHeader({
  value,
  onChange,
  placeholder,
  helperText
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  helperText?: string;
}) {
  return (
    <div className="w-full">
      {helperText && (
        <Tooltip target=".search-header-input" content={helperText} position="top" />
      )}
      <span className="p-input-icon-left w-full">
        <i className="pi pi-search ml-3"></i>
        <InputText
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="search-header-input pl-6 border rounded-md flex w-full block"
        />
      </span>
    </div>
  );
}
